import React, {useEffect} from 'react'
import actions from '../actions/terms'
import {connect} from 'react-redux'
import TermsComponent from "../components/Terms"
import {bool, func, shape, string} from "prop-types"

const Container = props => {
  const {code, countryCode} = props.match.params
  useEffect(() => {
    const {verifyAcceptance} = props
    verifyAcceptance(code)
  }, [])

  return <TermsComponent countryCode={countryCode} {...props}/>
}

Container.propTypes = {
  match: shape({
    params: shape({
      code: string,
    }).isRequired,
  }).isRequired,
  code: string.isRequired,
  accepted: bool.isRequired,
  acceptedTC: bool.isRequired,
  acceptedPrivacy: bool.isRequired,
  loadingTerms: bool.isRequired,
  loadingAccept: bool.isRequired,
  disabledButton: bool.isRequired,
  enableButton: func.isRequired,
  acceptTC: func.isRequired,
  verifyAcceptance: func.isRequired,
  acceptPrivacy: func.isRequired,
  errorTerms: string,
  error: string,
}

const mapStateToProps = state => state.ui.terms.terms

const mapDispatchToProps = dispatch => {
  return {
    verifyAcceptance: code => dispatch(actions.verifyAcceptance(code)),
    enableButton: () => dispatch(actions.enableButton()),
    acceptTC: () => dispatch(actions.acceptTC()),
    acceptPrivacy: code => dispatch(actions.acceptPrivacy(code)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/terms/containers/Terms.js